import { OrganizationCustomField } from '@/common/models';
import { Filter, FilterCollection, QueryParams } from '@/common/models/query-params';
import * as FilterComparisonOperator from '@/common/models/query-params/FilterComparisonOperator';
import API from '@/org-app/api';
import {
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewOrganizationCustomField(
    { commit },
    organizationCustomField = OrganizationCustomField.fromObject({
      id: -1,
    }),
  ) {
    commit(types.CREATE_ORGANIZATIONCUSTOMFIELD, organizationCustomField);
    return organizationCustomField;
  },
  getOrganizationCustomFields: createGetAllAction(
    API.instance.getOrganizationCustomFields,
    types.UPDATE_ORGANIZATIONCUSTOMFIELDS_LIST,
    'messages.failedToGetOrganizationCustomFields',
    true,
    null,
    new QueryParams( // Exclude custom fields associated with 'plan' entities (deprecated in CAM-5483)
      null,
      null,
      new FilterCollection([new Filter('entity', ['plan'], FilterComparisonOperator.NOT_EQUAL)]),
    ),
  ),
  getOrganizationCustomField: createGetOneAction(
    API.instance.getOrganizationCustomField,
    types.UPDATE_ORGANIZATIONCUSTOMFIELD,
    'messages.failedToGetOrganizationCustomField',
  ),
  createOrganizationCustomFields: createPostAction(
    API.instance.postOrganizationCustomFields,
    types.SAVE_ORGANIZATIONCUSTOMFIELDS,
    'messages.failedToCreateOrganizationCustomField',
  ),
  updateOrganizationCustomField: createPutAction(
    API.instance.putOrganizationCustomField,
    types.SAVE_ORGANIZATIONCUSTOMFIELDS,
    'messages.failedToUpdateOrganizationCustomField',
  ),
  deleteOrganizationCustomField: createDeleteAction(
    API.instance.deleteOrganizationCustomField,
    types.DELETE_ORGANIZATIONCUSTOMFIELD,
    'messages.failedToDeleteOrganizationCustomField',
  ),
  postOrganizationCustomFieldsValue: createPostAction(
    API.instance.postOrganizationCustomFieldsValue,
    null,
    'messages.failedToCreateOrganizationCustomFieldValue',
  ),
  updateOrganizationCustomFieldValue: createPutAction(
    API.instance.updateOrganizationCustomFieldsValue,
    null,
    'messages.failedToUpdateOrganizationCustomFieldValue',
  ),
  deleteOrganizationCustomFieldValue: createDeleteAction(
    API.instance.deleteOrganizationCustomFieldValue,
    null,
    'messages.failedToDeleteOrganizationCustomFieldValue',
  ),
};
